import ClientRegistration from '../../../components/Sales/ClientRegistration/ClientRegistration'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useSelectionTable from '../../../elements/Hooks/useSelectionTable'
import useSubmit from '../../../elements/Hooks/useSubmit'
import React from 'react'
import ClientsApi from '../../../api/Sales/Clients'

function ClientRegistrationCont (props) {
  const api = new ClientsApi()
  const { list, fetching, fetch } = useFetchList(api.registrations.list)

  const { tableRef, selection, selectAll, setSelection, toggleSelection, toggleAll, isSelected } = useSelectionTable()

  const [removing, removeFunc] = useSubmit(api.registrations.remove, true)

  async function removeSelection () {
    const removed = await removeFunc([...selection])
    await fetch()
  }

  return (
    <ClientRegistration
      {...{
        list,
        fetching,
        fetch,
        tableRef,
        selection,
        selectAll,
        setSelection,
        toggleSelection,
        toggleAll,
        isSelected,
        removeSelection,
        removing,
      }}
    />
  )
}

export default ClientRegistrationCont
